import { getIsLoggedIn } from '@api/selectors/auth';
import useWindowSize from '@hooks/useWindowSize';
import Dynamic from '@base/Dynamic/Dynamic';
import useEducatorContext from '@hooks/useEducatorContext';
import useMyInfo from '@api/hooks/auth/useMyInfo';

const Actions = Dynamic(() => import('@layout/Header/Actions'));
const SearchTab = Dynamic(() => import('@layout/Header/SearchTab'));
const HeaderNotification = Dynamic(() =>
  import('@layout/Header/HeaderNotification')
);
const HeaderUser = Dynamic(() =>
  import('@layout/Header/HeaderUser/HeaderUser')
);

const HeaderUserOptions = () => {
  const isEducatorSide = useEducatorContext();
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const { isMobile } = useWindowSize();

  return (
    <>
      {!isLoggedIn && <Actions isJoinForFreeCtaExperiment />}
      {!isMobile && isLoggedIn && (
        <>
          <SearchTab />
          <HeaderNotification />
          <HeaderUser isEducatorUrl={isEducatorSide} />
        </>
      )}
    </>
  );
};

export default HeaderUserOptions;
